import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import CustomInput from 'components/common/CustomInput/CustomInput';
import CustomNewConfirm from 'components/NewDesign/CustomNewConfirm';
import { changePassword } from 'api/authApi';

const EMPTY = { currentPassword: '', newPassword: '', confirmPassword: '' };

// Reusable in-app "Reset my password" dialog (personal-portal). Parent owns open/close.
const ChangePasswordModal = ({ isOpen, onClose }) => {
  const [saving, setSaving] = useState(false);
  const [values, setValues] = useState(EMPTY);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const close = () => {
    setValues(EMPTY);
    setErrors({});
    onClose();
  };

  const submit = async () => {
    const next = {};
    if (!values.currentPassword)
      next.currentPassword = 'Current password is required';
    if (!values.newPassword || values.newPassword.length < 8)
      next.newPassword = 'New password must be at least 8 characters';
    if (values.newPassword !== values.confirmPassword)
      next.confirmPassword = 'Passwords do not match';
    setErrors(next);
    if (Object.keys(next).length > 0) return;

    setSaving(true);
    try {
      await changePassword(values.currentPassword, values.newPassword);
      toast.success('Password changed.');
      close();
    } catch (e) {
      toast.error(
        e.response?.data?.message ||
          e.response?.data ||
          'Could not change your password.'
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <CustomNewConfirm
      isOpen={isOpen}
      title="Reset my password"
      confirmButtonText={saving ? 'Saving…' : 'Change password'}
      confirmButtonVariant="primary"
      cancelButtonText="Cancel"
      isLoading={saving}
      onConfirm={submit}
      onClose={close}
    >
      <div>
        <CustomInput
          label="Current password"
          name="currentPassword"
          type="password"
          value={values.currentPassword}
          error={errors.currentPassword}
          onChange={handleChange}
          style={{ marginBottom: 16 }}
        />
        <CustomInput
          label="New password"
          name="newPassword"
          type="password"
          value={values.newPassword}
          error={errors.newPassword}
          onChange={handleChange}
          style={{ marginBottom: 16 }}
        />
        <CustomInput
          label="Confirm new password"
          name="confirmPassword"
          type="password"
          value={values.confirmPassword}
          error={errors.confirmPassword}
          onChange={handleChange}
        />
      </div>
    </CustomNewConfirm>
  );
};

ChangePasswordModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ChangePasswordModal;
